export const getAudioFileDuration = (file: File): Promise<number> => {
  return new Promise((resolve, reject) => {
    const audio = document.createElement('audio')
    const url = URL.createObjectURL(file)

    audio.preload = 'metadata'
    audio.src = url

    audio.onloadedmetadata = () => {
      URL.revokeObjectURL(url)
      resolve(Math.round(audio.duration))
    }

    audio.onerror = () => {
      reject(new Error(`Ошибка загрузки аудиофайла`))
    }
  })
}
